<div class="container login">
	<div class="row">
		<div class="col-md-12">
			<div class="box mt40 mb40 static">
				<div class="row">
					<div class="col-lg-12">
						<div class="static-content dealer-content">
							<h2>Bayimiz Olun!</h2>
							<img src="assets/img/cardata-dealer.jpg" class="img-responsive" />
							<a href="/bayimiz-olun#basvuruformu" class="btn btn-m btn-primary pull-right mt-30">Bayilik
								Başvuru Formu</a>
							<h3>Otomotivin Bugünü ve Yarını artık Dijital!</h3>

							<p>Otomobil Satıcı olarak otomotivin “Dijital Geleceğinde” şimdiden yerinizi alın.<br />
								Geç Kalmayın! Cardata Bayisi olun!</p>

							<h3>Cardata Bayisi Olmak Size Ne Sunuyor?</h3>
							<p>Tüm Türkiye çapına yayılmış otomotivin dijital alım-satım platformu Cardata
								size:</p>

							<ul class="list mt--20">
								<li>Lider Marka ile çalışma avantajı</li>
								<li>Yüksek Bilinirlik</li>
								<li>Güçlü ve Güvenilir Marka İmajı</li>
								<li>Yüksek Karlılık</li>
							</ul>

							<p>sunuyor.</p>

							<h3>Artık Eski Tip Otomotiv Bayilikleri Dijital Dönüşümün Gerisinde Kalıyor!</h3>
							<ul class="list mb-20">
								<li>Artık geleneksel eski tip otomotiv bayiliklerinin otomotivde rekabet avantajı yok!
								</li>
								<li>Otomobil satıcısı iseniz veya otomobil alım-satım işine girmek istiyorsanız Cardata
									en doğru dijital adres.</li>
								<li>Cardata Bayiliği otomotivde işinizi de, işletmenizi de her dakika ileriye götürecek
									kapının anahtarıdır.</li>
							</ul>

							<h3>Cardata Bayisi Olmanın Avantajları</h3>
							<ul class="list mb-20">
								<li>Bilgiye, dataya saniyeler içinde ulaşın.</li>
								<li>Daha fazla müşteri edinin, daha fazla araç satışı yapın.</li>
								<li>Türkiye’de satılan 21.487 adet 2.el aracın gerçek ve güncel piyasa değerini sadece
									10 saniyede “<a [routerLink]="['/used_car_pricing']"><b>2.El
											Fiyatlandırma</b></a>” uygulamamız ile öğrenin.</li>
								<li>“<a [routerLink]="['/instant-cash-offer']"><b>Araç Tedariği Sağlama</b></a>” uygulamamız ile
									artık araç tedarik sıkıntınız olmasın.</li>
								<li>Artık kendinize ait bir “<a [routerLink]="['/used_car_pricing']"><b>Fiyatlandırma
											Modülünüz</b></a>” olsun, kar marjlarını siz belirleyin.</li>
								<li>Cardata’nın tüm Türkiye’deki güçlü marka bilinirliğinden ve tanınırlığından
									faydalanın.</li>
								<li>Tüm kurumsal kimlik ögelerinde Cardata marka standardına sahip olun.</li>
								<li>Reklam ve Pazarlama mecralarına yapacağımız 360 derece iletişim yatırımlarından
									ücretsiz faydalanın.</li>
								<li>Güvenilir bir markanın, tanınan bir markanın, kazandıran bir markanın, tercih edilen
									bir markanın ve Türkiye’nin en büyük firmalarının tercih ettiği bir markanın bayisi
									olun.</li>
								<li>Herhangi bir minimum M2 alan şartı yok, sadece otomobil alım-satım yapıyor veya
									yapacak olmanız yeterli. Unutmayın otomotiv artık dijital!</li>
							</ul>
							<h3>Şimdi Cardata Bayiliği alan İş Ortaklarımıza:</h3>

							<ul class="list mb-20">
								<li>Franchise Bedeli YOK!</li>
								<li>Bayilik Bedeli YOK!</li>
								<li>Yatırım Maliyeti YOK!</li>
								<li>Herhangi bir reklam kesinti bedeli YOK!</li>
								<li>Komisyon almak YOK!</li>
								<li>Minimum M2 alan şartı YOK!</li>
								<li>Önceliğimiz : <b>Bayimiz para kazanmalı!</b></li>
							</ul>
							<p>Unutmayın! Otomotiv sektöründe bunları yapabileceğiniz tek Dijital Platform
								Cardata’dır!<br />
								Şimdi Cardata Ailesi içindeki yerinizi geç kalmadan alın..</p>
							<p id="basvuruformu">&nbsp;</p>
							<h2>Bayilik Başvuru Formu</h2>
							<form [formGroup]="dealerForm">
								<div class="contact-widget dealer-form">
									<div class="row">
										<div class="col-md-6">
											<div class="form-group">
												<input class="contact-input" placeholder="Firma İsmi / Ünvanı"
													formControlName="company" [disabled]="formValid">
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<input class="contact-input" required placeholder="Yetkili Ad Soyad (*)"
													formControlName="name">
												<div class="text-danger" *ngIf="!nameValid">Ad Soyad bilgisi gerekli.</div>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<input class="contact-input" placeholder="Telefon (*)" prefix="+90"
													mask="(000) 000 00 00" formControlName="phone"
													(ngModelChange)="checkPhone()" [disabled]="formValid">
												<div class="text-danger" *ngIf="!phoneValid">Telefon numarasını kontrol ediniz.</div>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<input class="contact-input" type="email" placeholder="E-Posta (*)"
													formControlName="email" [disabled]="formValid">
												<div class="text-danger" *ngIf="!mailValid">Eposta adresini kontrol ediniz.</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-4">
											<div class="form-group">
												<select class="contact-input" formControlName="province"
													[disabled]="formValid">
													<option [ngValue]="0">Bayilik Talep Edilen İl*</option>
													<option *ngFor="let c of cityList" [ngValue]="c.Name">
														{{c.Name}}</option>
												</select>
												<div class="text-danger" *ngIf="!provinceValid">İl seçimi gerekli.</div>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<input class="contact-input" type="text" required placeholder="İlçe (*)"
													formControlName="district" [disabled]="formValid">
												<div class="text-danger" *ngIf="!districtValid">İlçe bilgisi gerekli.</div>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<input class="contact-input" placeholder="Web Sitesi"
													data-rule-required="false" type="text"	
													formControlName="website" [disabled]="formValid">
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<textarea placeholder="Mesaj" data-rule-required="false" id="Message"
													name="Message" formControlName="message"
													[disabled]="formValid"></textarea>
											</div>
										</div>

									</div>
									<div class="row">
										<div class="col-md-12 tac">
											<button formmethod="post" class="btn btn-primary btn-l" (click)="onSubmit()"
												*ngIf="!formValid">Gönder</button>
										</div>
										<div class="col-md-12" *ngIf="formValid">
											<div class="contact-success-card">
												<div class="contact-success-icon">✓</div>
												<h2 class="contact-success-title">Başvurunuz Alınmıştır!</h2>
												<p class="contact-success-desc">En kısa sürede sizinle iletişime geçeceğiz.</p>
											</div>
										</div>
									</div>
								</div>
							</form>
							<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
							<p>&nbsp;</p>
							<h2>Hakkımızda</h2>
							<img src="assets/img/shared/a-big-data-company.png" width="250" />

							<p>CarData®, 2012 yılında kurulan CDI (Car Data International®) Otomotiv Bilgi Hizmetleri A.Ş.®’nin premium otomotiv veri ve teknoloji markasıdır.</p>

							<p>%100 Türk mühendisliğiyle geliştirilen CarData®, Türkiye otomotiv pazarının kendine özgü dinamiklerini, ileri veri teknolojileri ve yapay zekâ destekli analiz yetkinlikleriyle bir araya getirir. Türkiye’nin ilk otomotiv veri şirketi olarak; pazardaki 0 km ve ikinci el araçlara ilişkin doğru, güncel ve kapsamlı verileri sektör profesyonellerinin, kurumların ve bireysel kullanıcıların hizmetine sunar.</p>

							<p>CarData®; Türkiye’nin en kapsamlı marka, model ve versiyon veri tabanını, uzman analistlerinin sektörel deneyimi ve gelişmiş teknolojik altyapısıyla sürekli olarak zenginleştirir. Büyük veri, yapay zekâ ve özgün algoritmalarla işlenen otomotiv verilerini anlamlı içgörülere dönüştürerek müşterilerine ve iş ortaklarına 360 derece bağımsız veri çözümleri sağlar. Böylece kurumların risklerini daha etkin yönetmelerine, bilgiye dayalı doğru kararlar almalarına ve sürdürülebilir rekabet avantajı elde etmelerine katkıda bulunur.</p>

							<p>CarData®, otomotiv sektörünün dijital dönüşümüne yön veren ürün ve hizmetleriyle; verinin toplanmasından doğrulanmasına, işlenmesinden analiz edilmesine ve karar destek çözümlerine dönüştürülmesine kadar tüm süreçleri uçtan uca yönetir. Güçlü teknolojik altyapısı sayesinde doğru ve güncel otomotiv verilerini yüksek performanslı, güvenilir ve kesintisiz çözümlerle iş ortaklarına ulaştırır.</p>

							<p>İnovasyonu ve sürekli gelişimi temel yaklaşım olarak benimseyen CarData®, insan uzmanlığını yapay zekâ ve ileri teknolojiyle buluşturarak otomotiv verisinin geleceğini şekillendirir.</p>

							<p>2012 yılından beri faaliyette olan CarData®, Türkiye’nin lider otomotiv veri şirketidir.</p>

							<p><b>Bilgi; Güç, Değer ve Kârlılıktır!</b></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>